import { CouponForms } from '../coupons/couponForms'
import { GoalsForm } from '../goals/goalsForm'
import { ModalHeader } from './modalHeader'
import { NavigatorButtonsToShowContent } from './navigatorButtonsToShowContent'
import { ModalFormsProvider } from './modalFormsContext'
import { useSelector } from 'react-redux'
import { useAdministrativeContext } from '../../../../pages/administrativePanel/administrativePanelContext'

import { Container } from './style'


export function ModalForms() {
    const modalFormsIsOpen = useSelector(state => state.modalForms.isOpen)
    const { informationsToShowInPage } = useAdministrativeContext()

    return( 
        <Container modalFormsIsOpen={modalFormsIsOpen}>

            <ModalFormsProvider>
                <ModalHeader />

                <NavigatorButtonsToShowContent />

                {
                    informationsToShowInPage === 'coupons' ?
                        <CouponForms />
                    :
                    informationsToShowInPage === 'goals'?
                        <GoalsForm/>
                    :
                    <></>
                }
            </ModalFormsProvider>
            
        </Container>
    )
}